import React from "react";
import assetPath from "utils/assetPath.utils";
import "./poster.component.scss";

interface Props {
  image: {
    desktop: string;
    mobile: string;
  };
}

const Poster: React.FC<Props> = (props) => {
  return (
    <div className="poster">
      <div className="poster__wrapper">
        <img src={assetPath(props.image.desktop)} />
      </div>
    </div>
  );
};

export default Poster;
